// extracted by mini-css-extract-plugin
export default {"RaportoModal":"Raporto_RaportoModal__1h5Xd","RaportoModalContent":"Raporto_RaportoModalContent__sEhgV"};